module.exports = function appendHelperScripts(md) {
  md.core.ruler.push('append-helper-scripts', function (state) {
    if (!state || !state.tokens) {
      return;
    }

    const classNames = [];
    state.tokens.forEach((token) => {
      if (!token.attrs) {
        return;
      }

      classNames.push(...token.attrs.filter((attr) => attr[0] === 'class').map((attr) => attr[1]));
    });

    // TODO: 1 つ追加したらこのサンプルは消す
    if (classNames.includes('append-helper-scripts-sample')) {
      md.helperScripts.add('https://kamigame.jp/kamigame-twitter-sharing/js/share-modal.js');
    }
  });
};
